'use strict';

var processInclude = require('base/util');

$(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/quickViewPdp'));
    processInclude(require('./product/socialNetworks'));
    processInclude(require('cybersource/product/detail'));
    processInclude(require('./product/pdpSummary'));
});
